import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid } from '@mui/material';
import { Input, Layout, Loading, UserNavbar } from '../../../components';
import { getVendorsByVenue, getVenueVendorUsers, onSearchUsers } from '../../../core/users/action';
import UsersTable from './Table';
import { getExpressLink } from '../../../core/balance/action';
import { GROUP_USER } from '../../../config/appGroupConfig';

const inputStyles = {
  backgroundColor: '#fffdfd98',
  borderRadius: 50,
  width: '100vw',
  height: 95,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#EE7B57',
};

function Transactions() {
  const dispatch = useDispatch();
  const [inputSearch, setInputSearch] = useState('');

  const {
    user,
    usersList,
    loading: usersLoading,
    usersFilteredList,
  } = useSelector((store) => store.users);
  const { expressLink, loading: balanceLoading } = useSelector((store) => store.balance);

  const onSearch = (e) => {
    setInputSearch(e.target.value);
    dispatch(onSearchUsers(e.target.value));
  };

  const getUsersList = () =>
    (usersFilteredList && usersFilteredList.length > 0) || inputSearch.trim() !== ''
      ? usersFilteredList
      : usersList;

  useEffect(() => {
    if (!user?.id) return;
    const isAdmin = user?.role.name === GROUP_USER.ADMIN;
    dispatch(getExpressLink(user.id, isAdmin));

    if (isAdmin) {
      dispatch(getVenueVendorUsers());
    } else {
      dispatch(getVendorsByVenue(user?.venue?.id));
    }
  }, [dispatch, user]);

  return (
    <Layout>
      <UserNavbar />
      {(usersLoading || balanceLoading) && <Loading />}

      <Grid container justifyContent="center" marginTop={30}>
        <Grid item xs={9} style={inputStyles} marginBottom={3}>
          <h1>Transactions</h1>
        </Grid>
        <Grid item xs={9} style={inputStyles}>
          <Input
            type="text"
            value={inputSearch}
            style={{ width: '65vw', marginTop: 4 }}
            placeholder="Typing some here..."
            onChange={onSearch}
          />
        </Grid>
        <Grid item xs={2} style={inputStyles}>
          <Button
            target="_blank"
            href={expressLink ?? 'https://dashboard.stripe.com/'}
            variant="contained">
            Go to Stripe
          </Button>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" marginTop={5}>
        <Grid xs={10}>
          <UsersTable usersList={getUsersList()} canRefund={user?.role.name === GROUP_USER.VENUE} />
        </Grid>
      </Grid>
    </Layout>
  );
}

Transactions.propTypes = {};

export default Transactions;
